/** Mirrors the backend's normalize_name: the identity under which a
 * name counts as already catalogued. Lowercase, non-letter characters
 * stripped, words joined with "_"; a name with no letters becomes "". */
export const normalizeName = (raw: string) =>
  raw
    .toLowerCase()
    .split(/\s+/)
    .map(word => word.replace(/[^\p{L}]/gu, ""))
    .filter(Boolean)
    .join("_");
